export const appVersion = '1.4.1'
export const protocolName = 'ArCode'
export const protocolVersion = '1'
